import { FilledButton } from 'components/Custom'
import { SidebarBox } from 'components/Custom'
import { SideBarContainer } from 'components/Custom'
import { SidebarFooter } from 'components/Custom/SidebarFooter'
import { SidebarHeader } from 'components/Custom/SidebarHeader/Web/index'

import useSidebarStore from 'store/useSidebar'
import formataData, { formataDataHora } from 'utils/formataData'
import { useIsMobile } from 'hooks/useIsResponsive'
import { Box } from 'components/Material/Box'
import { TopAppBar } from 'components/Custom'
import { Rotas } from 'routes/rotas'
import { maskCNPJCPF } from 'utils/formataValidaDocumentos'
import { TODAY_DATE } from 'utils/variablesAndSelects'
import { useEffect, useState } from 'react'
import useDocumentsManagementStore from 'store/useDocumentsManagementStore'
import { LIST_DOCUMENT_STATUS_SELECT } from 'enums/selects'
import { useDocumentManagementHook } from 'hooks/useDocumentManagementHook'
import { HandlerErrorMessage } from 'utils/HandlerErrorMessage'
import { SidebarBody } from 'components/Custom'
import { Progress } from 'components/Custom/Progress'
import { HeadlineText, LabelText } from 'components/Custom/Typographies'
import { LabelValuePair } from 'components/Custom'
import DocumentItem from '../components/DocumentItem'
import useUserInfoStore from 'store/useUser'
import { DocumentApprovalType } from 'types/documentos'
import { useSnackbarAlertContext } from 'contexts/SnackbarContext'
import { SnackbarAlert } from 'components/Custom'
import { documentsSidebarIds } from './SidebarConfig'

export type DocumentStatus = 'P' | 'A' | 'R' | 'E'

const DetailsSidebar = () => {
  const { openSidebar, closeSidebar } = useSidebarStore((state) => state)
  const isMobile = useIsMobile()
  const [showMessage, setShowMessage] = useState(false)
  const { showAlert } = useSnackbarAlertContext()

  const {
    proposal,
    setDocumentToUpload,
    setDocumentToDownload,
    includeInStage,
    deleteFromStage,
    clearStage,
    clearProposal,
    stage
  } = useDocumentsManagementStore((state) => state)

  const { handlerSaveUpdate, getDocumentApprovalFileMutation, isSaveLoading, isLoading } =
    useDocumentManagementHook()
  const { privilegios } = useUserInfoStore((state) => state)

  const mountTextUserDate = (data: string, user: string) => {
    const formattedDateTime = formataDataHora(data)
    return `Enviado em ${formattedDateTime} por ${user ?? ''}`
  }

  useEffect(() => {
    console.log('proposal', proposal)
    if (proposal && new Date(proposal?.dt_vencimento) < TODAY_DATE) {
      setShowMessage(true)
    }
  }, [proposal])

  const handleUploadFile = (document: DocumentApprovalType) => {
    if (privilegios.sn_documentacoes_altera === 'N') {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Este usuário não tem permissão para realizar esta ação'
      })
      return
    }

    setDocumentToUpload({
      file: null,
      salvar_arquivo: false,
      id_corcc080: document.id_corcc080,
      id_concc070: document.id_concc070,
      nm_documento: document.nm_documento
    })
    openSidebar(documentsSidebarIds.UPLOAD_FILE)
  }

  const handleDownloadFile = async (document: DocumentApprovalType) => {
    if (privilegios.sn_documentacoes_relatorio === 'N') {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Este usuário não tem permissão para realizar esta ação'
      })
    }
    if (proposal) {
      const payload = {
        id_corcc080: document.id_corcc080,
        id_documento: proposal.id_documento
      }
      const response = await getDocumentApprovalFileMutation.mutateAsync(payload)
      if (!response) {
        return HandlerErrorMessage({
          showAlert,
          customErrorMessage: 'Erro ao tentar baixar o arquivo'
        })
      }
      setDocumentToDownload(response)
      openSidebar(documentsSidebarIds.DOWNLOAD_FILE)
    }
  }

  const handlerDelete = (document: DocumentApprovalType) => {
    if (privilegios.sn_documentacoes_exclui === 'N') {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Este usuário não tem permissão para realizar esta ação'
      })
      return
    }
    const itemStage = stage.edit.find((doc) => {
      return doc.id_corcc080 === document.id_corcc080
    })
    if (itemStage) {
      deleteFromStage(document.id_corcc080, 'edit')
    }
    if (proposal) {
      includeInStage({ id_corcc080: document.id_corcc080, id_documento: proposal.id_documento })
    }
  }

  const handlerChangeStatus = (document: DocumentApprovalType, newStatus: DocumentStatus) => {
    if (privilegios.sn_permite_aprovar_reprovar === 'N') {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Este usuário não tem permissão para alterar o status do documento'
      })
      return
    }

    if (document.st_status === newStatus) {
      deleteFromStage(document.id_corcc080, 'edit')
    } else if (proposal) {
      includeInStage({
        id_corcc080: document.id_corcc080,
        id_documento: proposal.id_documento,
        st_status: newStatus
      })
    }
  }

  const statusValue = (originalStatus: string, id_corcc080: number) => {
    if (stage.edit.length === 0) {
      return originalStatus
    } else {
      const document = stage.edit.find((doc) => doc.id_corcc080 === id_corcc080)
      if (document) {
        return document.st_status
      }
    }
    return originalStatus
  }

  const checkIfDocumentToDelete = (id_corcc080: number) => {
    return stage.delete.some((item) => item.id_corcc080 === id_corcc080)
  }

  const handlerClose = () => {
    clearStage()
    clearProposal()
    closeSidebar()
  }

  const checkIfHasActionsToUpdate = () => {
    return stage.delete.length > 0 || stage.edit.length > 0
  }

  return (
    <SideBarContainer>
      {isMobile ? (
        <TopAppBar route={Rotas.DOCUMENTACAO} closeSidebar={handlerClose} leftText="Detalhe" />
      ) : (
        <SidebarHeader title="Detalhe" onClick={handlerClose} />
      )}
      <Box className="flex flex-col justify-center items-center ">
        <Box className="p-5 flex flex-col gap-5 w-full max-w-[390px]">
          <SnackbarAlert
            message="Possui parcelas em atraso!"
            statusType="message"
            closeFunction={() => setShowMessage(false)}
            duration={3000}
            className="relative w-full bottom-0 left-0 right-0"
            open={showMessage}
          />
          <SidebarBox>
            <HeadlineText
              text={maskCNPJCPF(proposal?.cd_inscricao_nacional ?? '')}
              typeStyle="large"
            />
          </SidebarBox>
        </Box>
      </Box>
      {(proposal && Object.keys(proposal).length === 0) || isLoading ? (
        <Box className="flex justify-center py-10 flex-grow">
          <Progress />
        </Box>
      ) : (
        <SidebarBody className="flex-grow">
          <Box className="flex flex-col w-full items-center">
            <Box className="px-5 pb-5 flex flex-col gap-5 w-full max-w-[390px]">
              <SidebarBox>
                <Box className="w-full flex flex-col gap-5">
                  <LabelText text="Dados do cliente" typeStyle="large" />
                  <LabelValuePair label="Nome completo" value={proposal?.nm_pessoa ?? '-'} />
                  <LabelValuePair label="Proposta número" value={proposal?.id_documento ?? '-'} />
                  <LabelValuePair
                    label="Vencimento"
                    value={formataData(proposal?.dt_vencimento ?? '')}
                  />
                </Box>
              </SidebarBox>
              <Box className="flex flex-col flex-grow gap-5">
                <Box className="flex">
                  <LabelText text="Documentos anexados" typeStyle="large" />
                </Box>
                {proposal?.documentos.map((document, index) => (
                  <DocumentItem
                    proposalStatus={proposal.st_status}
                    key={index}
                    document={document}
                    index={index}
                    divider={index !== proposal.documentos.length - 1}
                    handleUploadFile={handleUploadFile}
                    handleDownloadFile={handleDownloadFile}
                    handlerDelete={handlerDelete}
                    handlerChangeStatus={handlerChangeStatus}
                    statusValue={statusValue}
                    checkIfDocumentToDelete={checkIfDocumentToDelete}
                    mountTextUserDate={mountTextUserDate}
                    LIST_DOCUMENT_STATUS_SELECT={LIST_DOCUMENT_STATUS_SELECT}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </SidebarBody>
      )}
      <SidebarFooter>
        <Box className="w-full max-w-[350px]">
          <FilledButton
            disabled={!checkIfHasActionsToUpdate()}
            onClick={() => handlerSaveUpdate(proposal?.id_documento ?? 0)}
            loading={isSaveLoading}
          >
            Salvar
          </FilledButton>
        </Box>
      </SidebarFooter>
    </SideBarContainer>
  )
}

export default DetailsSidebar
